import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { DonationCategoryService } from 'src/app/shared/API-Service/services/donation-category.service';

@Component({
  selector: 'app-insert-donation-category',
  templateUrl: './insert-donation-category.component.html',
  styleUrls: ['./insert-donation-category.component.css']
})
export class InsertDonationCategoryComponent implements OnInit {
  recordtoupdate: any;
  DonationcategoryForm : FormGroup;
update:boolean = false;
button:boolean = false;
  constructor(private _DonationCategoryService:DonationCategoryService, private _Router:Router, private _FormBuilder:FormBuilder ) { }

  ngOnInit(): void {
    this.initiate();
    this.checkEdit();
  }

  initiate(){
    this.DonationcategoryForm = this._FormBuilder.group({
      title: ['', Validators.required],
    });
  }

  checkEdit() {
    this._DonationCategoryService.Data.subscribe((res) => {
      if (res != null) {
        this.DonationcategoryForm = this._FormBuilder.group({
          title: [res.title, Validators.required],
        });
        this.update = true;
        this.recordtoupdate = res ;
      
      } else {
        console.log(`not found on data`);
        // this.initiate();
      }
     
    });
  }
  get fc() {
    return this.DonationcategoryForm.controls;
  }
 
  onSubmit(){
    this.button = true;
   if(this.update == false && this.DonationcategoryForm.status == "VALID"){
  
    this._DonationCategoryService.CreateDonationCategory(this.DonationcategoryForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.DonationcategoryForm.reset();
      this._Router.navigate(['/content/admin/ViewDonationCategory']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   } else if(this.DonationcategoryForm.status == "VALID"){
    this.DonationcategoryForm.addControl('id', new FormControl(this.recordtoupdate.id, Validators.required));
    this._DonationCategoryService.UpdateDonationCategory(this.DonationcategoryForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.DonationcategoryForm.reset();
      this._Router.navigate(['/content/admin/ViewDonationCategory']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"Please check that all the fields are written"   
    })
    this.DonationcategoryForm.markAllAsTouched();
    this.button = false;
   }
  }

  
  ngOnDestroy(){
    this._DonationCategoryService.Data.next(null);
     }
}
